import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "soft-unwrap",
  "use": "soft-unwrap-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"soft-unwrap\"><title>icn/soft-unwrap</title><path d=\"M2 3h12a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2zm5 8v-.521c0-.263.189-.477.422-.477.079 0 .156.025.223.073l2.157 1.523c.197.14.257.433.134.657a.453.453 0 0 1-.134.151L7.645 13.93c-.197.14-.457.071-.58-.152A.523.523 0 0 1 7 13.525V13H2a1 1 0 0 1 0-2h5zM2 7h12a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2zm10 4h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2z\" id=\"soft-unwrap_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol